import { Stack, Typography } from '@mui/material';

const RegisterFieldCheckboxLabel = ({ label, helperText }) => {
  return (
    <Stack spacing={0.5}>
      <Typography fontSize="0.875rem">{label}</Typography>
      <Typography fontSize="0.7rem" fontStyle="italic">
        {helperText}
      </Typography>
    </Stack>
  );
};

export default RegisterFieldCheckboxLabel;
